export default "__VITE_PUBLIC_ASSET__d47952e5__"